import { type AxiosInstance } from "axios";
import type { DesignFormData, Design } from "@/features/dmManagement/types";
import { handleMutationError } from "@/features/dmManagement/api/handleApiError";

/**
 * 新規デザインを登録する。
 * @param apiClient - axios インスタンス
 * @param data - デザインフォーム入力データ（タスク情報・カテゴリ・構成ファイル）
 * @returns 作成されたデザイン情報
 */
export const PostDesignAPI = async (
  apiClient: AxiosInstance,
  data: DesignFormData
): Promise<Design> => {
  const url = "/dm/designs/";

  // FormDataはJSON→snake_case自動変換(axios-case-converter)の対象外のため、キー名を直接snake_caseで指定する
  const formData = new FormData();
  formData.append("task_id", String(data.taskId));
  formData.append("task_name", data.taskName);
  formData.append("category_id", String(data.categoryId));

  data.components.forEach((component, index) => {
    formData.append(
      `components[${index}]product_id`,
      String(component.productId)
    );
    formData.append(
      `components[${index}]enclosing_seq`,
      String(component.enclosingSeq)
    );
    formData.append(`components[${index}]file`, component.file);
  });

  try {
    const response = await apiClient.post<Design>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return handleMutationError(error);
  }
};
